module.exports = __webpack_public_path__ + "static/media/bubble_design_top.f0860cd2.svg";